import $ from 'jquery';
import '../../../../node_modules/bootstrap/js/dist/collapse.js';

(function($){

    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    15/4/19
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function( $block ) {

        let desktopSize;

        checkWindowSize();
        setUpAccordionTransition();

        function checkWindowSize() {
            if ($(window).width() <= 767) {
                desktopSize = false;
            } else {
                desktopSize = true;
            }
        }

        var resizeTimer;

        $(window).resize(function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function(){
                checkWindowSize();
                setUpAccordionTransition();
            }, 200);
        });

        let firstTab = $block.find('.card:first-child');
        let firstTabContent = firstTab.find('.collapse');
        let firstTabButton = firstTab.find('.card-header button');
        let collapsedButtons = $block.find('.card:not(.active) .card-header button');
        let accordionButtons = $block.find('.card .card-toggle');

        /* Activate first tab on init for all accordion instances */
        firstTab.addClass('active');
        firstTabContent.addClass('show');
        firstTabButton.attr('aria-expanded', 'true');
        collapsedButtons.addClass('collapsed');

        let activeCard = $block.find('.card.active');
        activeCard.next().find('.card-toggle').addClass('card-border-left');

        accordionButtons.click(function(e) {
            toggleAccordionClasses(e);
        });

        /* Accordion navigation */
        let accordionNav = $block.find('.accordion-navigation');
        let accordionNavButtons = $block.find('.accordion-navigation li:not(.active)');
        let accordionFirstTab = $block.find('.accordion-navigation li:first-child');
        accordionFirstTab.addClass('active');

        accordionNavButtons.click(function(e) {
           e.preventDefault();
            toggleAccordionClasses(e);
        });

        /* Handle toggling classes */
        function toggleAccordionClasses(e) {
            $block.find('.card').removeClass('active');

            let targetTab = $(e.target).attr('data-navigation');
            $block.find($('#'+targetTab)).closest('.card').toggleClass('active');

            accordionNav.find('li').removeClass('active');
            accordionNav.find($('.'+targetTab)).addClass('active');

            let activeCard = $('.card.active');
            $block.find('.card .card-toggle').removeClass('card-border-left');
            activeCard.next().find('.card-toggle').toggleClass('card-border-left');
        }

        /* Smoother transition */
        function setUpAccordionTransition() {
            const horizontalAccordions = $block;

            horizontalAccordions.each((index, element) => {
                const accordion = $(element);
                const collapse = accordion.find('.collapse');
                const bodies = accordion.find('.card-transition .card-body');
                const accordionWidth = accordion.width();
                const accordionNavs = accordion.find('.card-header');
                let accordionNavWidth = 0;
                accordionNavs.each(function(){
                    accordionNavWidth += $(this).outerWidth();
                });
                const accordionContentWidth = accordionWidth - accordionNavWidth;

                if (desktopSize) {
                    collapse.removeClass('height').addClass('width');
                    bodies.width(accordionContentWidth);
                    bodies.height('');
                } else {
                    collapse.removeClass('width').addClass('height');
                    bodies.width('');
                    bodies.height('100%');
                }

                collapse.not('.show').each((index, element) => {
                    $(element).parent().find('[data-toggle="collapse"]').addClass('collapsed');
                });
            });
        }
    }

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.step-accordion').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=step-accordion', initializeBlock );
    }

})(jQuery);
